import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isWithdrawShiftAllowOvertimeEnabledForCommunitySelector = (communityId?: number) =>
  createSelector(getUserPermissions, (userPermissions) => {
    const permission = userPermissions?.WITHDRAW_SHIFT_ALLOW_OVERTIME;
    if (!communityId || !permission?.access.includes('read')) return false;
    return !!permission.communities?.[communityId]?.includes('read');
  });
